import { theme } from 'antd';
import { useEffect, type PropsWithChildren } from 'react';

/**
 * Bridges Ant Design's theme tokens to CMP's CSS variables on :root.
 * This ensures the cookie consent banner (position: fixed) respects light/dark mode.
 */
export function ThemedCmp({ children }: PropsWithChildren) {
  const { token } = theme.useToken();

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--cmp-bg', token.colorBgElevated);
    root.style.setProperty('--cmp-text', token.colorText);
    root.style.setProperty('--cmp-border', token.colorBorder);
    root.style.setProperty('--cmp-shadow', token.boxShadow);
    root.style.setProperty('--cmp-radius', `${token.borderRadius}px`);
    root.style.setProperty('--cmp-btn-primary-bg', token.colorPrimary);
    root.style.setProperty('--cmp-btn-primary-text', token.colorWhite);
    root.style.setProperty('--cmp-btn-secondary-bg', token.colorBgContainer);
    root.style.setProperty('--cmp-btn-secondary-text', token.colorText);
    root.style.setProperty('--cmp-btn-secondary-border', token.colorBorder);
  }, [token]);

  return children;
}
